import { type ThemeOptions } from '@mui/material';

export const palette: ThemeOptions['palette'] = {
  primary: {
    main: '#0066ff',
  },
  secondary: {
    main: '#13f6fa',
  },
  status: {
    success: '#198754',
    error: '#dc3545',
    warning: '#ffc107',
    info: '#0dcaf0',
  },
  success: {
    main: '#198754',
  },
  error: {
    main: '#dc3545',
  },
  warning: {
    main: '#ffc107',
  },
  info: {
    main: '#0dcaf0',
  },
  brand: {
    main: '#0066ff',
    secondary: '#13f6fa',
  },
  border: {
    main: '#e0e0e0',
  },
  text: {
    main: '#495057',
    dark: '#222024',
    soft: '#6c757d',
    white: '#ffffff',
    brand: {
      color_1: '#01FC93',
      color_2: '#4800F8',
    },
    grey: {
      blue_1: '#666C7F',
      blue_2: '#A5ACBB',
      blue_3: '#D0D4DE',
      light: '#F3F3F3',
    },
  },
  background: {
    dark: '#222024',
    soft: '#f8f9fa',
    light: '#EDEFF0',
    softHover: '#e9ecef',
    white: '#ffffff',
    brand: {
      color_1: '#01FC93',
      color_2: '#4800F8',
    },
    grey: {
      blue_1: '#666C7F',
      blue_2: '#A5ACBB',
      blue_3: '#D0D4DE',
      light: '#F3F3F3',
    },
  },
};
